<template>
	<DefaultLayout :title="`: ${title}`" :goBackUrl="'/'">
		<template #layout__header-info>
			<div class="search">
				<svg width="20" height="20">
					<use xlink:href="sprite.svg#search"></use>
				</svg>
				<input
					class="search__input"
					placeholder="Поиск"
					type="text"
					v-model="searchQuery"
					@input="filterQuestions"
				/>
			</div>
		</template>

		<template #layout__content>
			<div class="chapterPage__content">
				<div v-for="(item, idx) in options" :key="idx">
					<EpkQuestion
						:question="highlightText(item.title)"
						:instructions="item.instructions"
					/>
				</div>
			</div>
		</template>
	</DefaultLayout>
</template>

<script setup>
import EpkQuestion from '@/components/EpkQuestion/EpkQuestion.vue';
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import DefaultLayout from '../DefaultLayout/DefaultLayout.vue';

import options_account from '@/options/options_account.js';
import options_agg from '@/options/options_agg.js';
import options_epgu from '@/options/options_epgu.js';
import options_epk from '@/options/options_epk.js';
import options_lph from '@/options/options_lph.js';

const route = useRoute();
const page = route.params.page;

const options = {
	epk: options_epk,
	epgu: options_epgu,
	account: options_account,
	lph: options_lph,
	agg: options_agg,
}[page];

const title = {
	epk: 'похозяйственная книга',
	epgu: 'ЕПГУ',
	account: 'реестр лицевых счетов',
	lph: 'карточки ЛПХ',
	agg: 'агрегированные данные',
}[page];

const searchQuery = ref('');
const filteredOptions = ref(options);

const filterQuestions = () => {
	const query = searchQuery.value.toLowerCase();

	filteredOptions.value = options.filter((item) =>
		item.title.toLowerCase().includes(query)
	);
};

const highlightText = (text) => {
	const query = searchQuery.value;
	if (!query) return text;

	const regex = new RegExp(`(${query})`, 'gi');
	return text.replace(regex, '<span class="highlight">$1</span>');
};
</script>

<style lang="scss">
@import './EpkChapterPage.scss';
</style>
